export const ADVISER_EVENTS = {
  WidgetDisplayed: 'displayed adviser widget',
  GreetingDismissed: 'dismissed adviser greeting',
  WidgetViewed: 'viewed adviser widget',
  WidgetClosed: 'closed adviser widget',
  ConversationStarted: 'started adviser conversation',
  ConversationResumed: 'resumed adviser conversation',
  SourceClicked: 'clicked adviser source',
  HistoryOpened: 'opened adviser conversation history',
  NewConversationClicked: 'clicked adviser new conversation',
  DeleteConversationClicked: 'clicked adviser delete conversation',
  ChatFailed: 'adviser chat failed',
  EntryPointClicked: 'clicked adviser entry point',
  MessagesListViewed: 'viewed adviser messages list',
  MessageThreadOpened: 'opened adviser message thread',
  MessageReplySent: 'sent adviser message reply',
  AttachmentAdded: 'added adviser attachment',
  AttachmentUploadFailed: 'adviser attachment upload failed',
  AttachmentRemoved: 'removed adviser attachment',
  AttachmentsSubmitted: 'submitted adviser attachments',
  NextStepClicked: 'clicked adviser next step',
} as const

export type AdviserEventName =
  (typeof ADVISER_EVENTS)[keyof typeof ADVISER_EVENTS]

export const HAVEN_COHORT_ALPHA = 'alpha'
